import { ResolutionsSrcSet, StaticImage } from '@/common/constants/displateRoutes';
import SvgIconPoster from '@/common/icons/generated/common/IconPoster';
import { Testimonial } from '@/modules/HomePage/components/Referrals/Referrals.data';

import styles from './ReferralsSlide.module.scss';

const assetPath = '/images/homepage/referrals/';

interface ReferralsSlideProps {
  testimonial: Testimonial;
}

const ReferralsSlide = ({ testimonial }: ReferralsSlideProps) => {
  return (
    <div className={styles.container}>
      <a className={styles.imageContainer} href={testimonial.displateLink.toString()}>
        <picture>
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${testimonial.id}_image.avif`),
              x2: StaticImage(`${assetPath}${testimonial.id}_image@2x.avif`),
            })}
            type="image/avif"
          />
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${testimonial.id}_image.webp`),
              x2: StaticImage(`${assetPath}${testimonial.id}_image@2x.webp`),
            })}
            type="image/webp"
          />
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${testimonial.id}_image.jpg`),
              x2: StaticImage(`${assetPath}${testimonial.id}_image@2x.jpg`),
            })}
            type="image/jpeg"
          />
          <img
            alt={testimonial.body}
            className={styles.image}
            loading="lazy"
            src={StaticImage(`${assetPath}${testimonial.id}_image.jpg`)}
            width={'100%'}
          />
        </picture>
        <button className={styles.buttonCta}>
          <SvgIconPoster height={12} width={12} />
          Show&nbsp;Displates
        </button>
      </a>
      <p className={styles.content}>{testimonial.body}</p>
      <a
        className={styles.userInfo}
        href={testimonial.socialNetworkLink.toString()}
        rel="noopener noreferrer"
        target="_blank"
      >
        <picture>
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${testimonial.id}_avatar.avif`),
              x2: StaticImage(`${assetPath}${testimonial.id}_avatar@2x.avif`),
            })}
            type="image/avif"
          />
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${testimonial.id}_avatar.webp`),
              x2: StaticImage(`${assetPath}${testimonial.id}_avatar@2x.webp`),
            })}
            type="image/webp"
          />
          <source
            srcSet={ResolutionsSrcSet({
              x1: StaticImage(`${assetPath}${testimonial.id}_avatar.jpg`),
              x2: StaticImage(`${assetPath}${testimonial.id}_avatar@2x.jpg`),
            })}
            type="image/jpeg"
          />
          <img
            alt={testimonial.body}
            className={styles.avatar}
            loading="lazy"
            src={StaticImage(`${assetPath}${testimonial.id}_avatar.jpg`)}
            width={30}
          />
        </picture>
        <div>
          <div className={styles.userDisplayName}>{testimonial.socialNickToDisplay}</div>
          <div className={styles.userSocialName}>{testimonial.socialNick}</div>
        </div>
      </a>
    </div>
  );
};

export default ReferralsSlide;
